import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowLeft, SkipForward } from 'lucide-react';
import { truthQuestions, darePrompts } from '../../data/mockData';

export default function TruthOrDare({ onBack }) {
  const { t } = useLanguage();
  const [mode, setMode] = useState(null); // 'truth' | 'dare'
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dareIndex, setDareIndex] = useState(0);

  const currentContent = mode === 'truth'
    ? truthQuestions[currentIndex % truthQuestions.length]
    : mode === 'dare'
    ? darePrompts[dareIndex % darePrompts.length]
    : null;

  const handleChoice = (choice) => {
    setMode(choice);
  };

  const handleNext = () => {
    if (mode === 'truth') setCurrentIndex(prev => prev + 1);
    else setDareIndex(prev => prev + 1);
    setMode(null);
  };

  return (
    <div data-testid="tod-game" className="p-4">
      <button data-testid="game-back-btn" onClick={onBack}
        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-4 text-sm">
        <ArrowLeft className="w-4 h-4" /> Back to games
      </button>
      <div className="text-center mb-6">
        <div className="text-4xl mb-2">{'\u{1F3B2}'}</div>
        <h3 className="font-display text-xl font-bold">{t('truthOrDare')}</h3>
        <p className="text-xs text-slate-400 mt-1">Always skippable - no pressure!</p>
      </div>

      {!mode ? (
        <div className="flex gap-4">
          <button data-testid="truth-btn" onClick={() => handleChoice('truth')}
            className="flex-1 py-8 rounded-2xl bg-blue-500/10 text-blue-400 hover:bg-blue-500/20 transition-all text-center">
            <div className="text-3xl mb-2">{'\u{1F4AC}'}</div>
            <span className="text-lg font-semibold">{t('truth')}</span>
          </button>
          <button data-testid="dare-btn" onClick={() => handleChoice('dare')}
            className="flex-1 py-8 rounded-2xl bg-[#FF007F]/10 text-[#FF007F] hover:bg-[#FF007F]/20 transition-all text-center">
            <div className="text-3xl mb-2">{'\u{1F525}'}</div>
            <span className="text-lg font-semibold">{t('dare')}</span>
          </button>
        </div>
      ) : (
        <>
          <div className="glass-card rounded-2xl p-6 text-center mb-6">
            <span className={`text-xs font-semibold uppercase tracking-wider ${mode === 'truth' ? 'text-blue-400' : 'text-[#FF007F]'}`}>
              {mode === 'truth' ? t('truth') : t('dare')}
            </span>
            <p className="text-lg font-medium leading-relaxed mt-3">{currentContent}</p>
          </div>
          <div className="flex justify-center gap-3">
            <button data-testid="skip-tod-btn" onClick={handleNext}
              className="px-6 py-2 rounded-full bg-white/5 hover:bg-white/10 text-sm flex items-center gap-2 transition-all">
              <SkipForward className="w-4 h-4" /> {t('skip')}
            </button>
            <button data-testid="next-tod-btn" onClick={handleNext}
              className="px-6 py-2 rounded-full gradient-button text-sm">
              {t('next')}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
